import { Component, OnInit, ChangeDetectorRef, ElementRef, Renderer2 } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { MenuAsideService } from 'src/app/core/_base/layout/services/menu-aside.service';
import { MenuHorizontalService } from 'src/app/core/_base/layout/services/menu-horizontal.service';
import { UtilsService } from 'src/app/Services/utils.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthApiService } from 'src/app/Services/auth.service';
import { AuthNoticeService } from '../auth-notice/auth-notice.service';
import { LayoutConfigService } from 'src/app/core/_base/layout/services/layout-config.service';
import { SplashScreenService } from 'src/app/core/_base/layout/services/splash-screen.service';
import { UserData } from 'src/app/Services/data.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  isLoggedIn$: Observable<boolean>;
  errorMessage: string;
  HarError: boolean = false; 
  browserDomain
  headerLogo: string;
  entity: any;
  logoFlag: boolean;
  today: number = Date.now();
  entityList: UserData [];
  selectedEntity: any;
  session: any;
  disableInstitute: boolean;
  copyrightName : any = 'Loading';
  displayLogo = './../../../../assets/images/fluidLoader.gif'
  displayDescription: string = 'Loading...';
  displayName: string = 'Loading';
  privacyPolicyUrl: string ='';
  tncUrl: string = '';
  disclaimerUrl: string = '';
  privacyPolicyFlag: boolean;
  tncFlag: boolean;
  disclaimerFlag: boolean;
  constructor(private el: ElementRef, private render: Renderer2, private layoutConfigService: LayoutConfigService,
    private splashScreenService: SplashScreenService, private util : UtilsService, private api: AuthApiService, private menuAside: MenuAsideService,
    private menuHorizontal:MenuHorizontalService, private ref : ChangeDetectorRef, private route: ActivatedRoute,
   private fb: FormBuilder, private authNoticeService: AuthNoticeService, private router: Router) { 
  
 }


  ngOnInit() {
    this.headerLogo = this.layoutConfigService.getLogo();
   this.setWhiteLabelling();
		this.splashScreenService.hide();
    this.openEntityList();
    this.validateForm()
    this.browserDomain = this.api.browserDomain;
    let qac = this.route.snapshot.paramMap.get('qac');
    if(qac == 'staff'){
      this.util.redirect('auth/login/staff')
    }else{
      this.api.getEntityByQac(qac)
      .subscribe(res=>{
        this.entity = res;
        this.session = res.activeSession.name
        this.logoFlag = true;
        this.ref.detectChanges();
        setTimeout(() => {
          for(let item of this.entityList){
            if(item._id == this.entity._id){
              this.selectedEntity = item;
              this.disableInstitute = true;
              this.ref.detectChanges();
            }
          }
        }, 1000);
      },err=>{
        this.logoFlag = false;
        this.util.redirect('auth/login')
      })
    
    }
  }
  setWhiteLabelling(){
    setTimeout(() => {
      if(localStorage.getItem('copyrightName')){
        this.copyrightName = localStorage.getItem('copyrightName')
      }
      if(localStorage.getItem('displayLogo')){
        this.displayLogo = localStorage.getItem('displayLogo')
      }
      // if(localStorage.getItem('titleName')){
      //   this.titleName = localStorage.getItem('titleName')
      // }
      if(localStorage.getItem('displayDescription')){
        this.displayDescription = localStorage.getItem('displayDescription')
      }
      if(localStorage.getItem('displayName')){
        this.displayName = localStorage.getItem('displayName')
      }
      if(localStorage.getItem('privacyPolicyUrl')){
        this.privacyPolicyFlag = true;
        this.privacyPolicyUrl = localStorage.getItem('privacyPolicyUrl')
      }else{
        this.privacyPolicyFlag = false;
      }
      if(localStorage.getItem('tncUrl')){
        this.tncFlag = true;
        this.tncUrl = localStorage.getItem('tncUrl')
      }else{
        this.tncFlag = false;
      }
      if(localStorage.getItem('disclaimerUrl')){
        this.disclaimerFlag = true;
        this.disclaimerUrl = localStorage.getItem('disclaimerUrl')
      }else{
        this.disclaimerFlag = false;
      }
      if(localStorage.getItem('loginRedirect') && localStorage.getItem('loginRedirect') == 'staff'){
        let qac = this.route.snapshot.paramMap.get('qac');
        let str;
        if(qac){
          str = 'auth/'+qac+'/staff';
        }
        else{
          str = 'auth/login/staff'
          // this.util.redirect('auth/login/staff')
        }
        this.util.redirect(str);
        return;
      }
      this.ref.detectChanges();
    }, 1000);
    
  }
  redirectToURL(url){
    window.open(url,  "_blank");
  }
  redirect(route){
    this.util.redirect(route);
  }
  validateForm() {
		this.loginForm = this.fb.group({
			mobile: ['', Validators.compose([
				Validators.required,
				// Validators.minLength(10),
        // Validators.maxLength(10),
        Validators.pattern("[0-9{10,10} \'\-]+$")
        
			]),
			],
			password: ['', Validators.compose([
				Validators.required,
				Validators.minLength(2),
        Validators.maxLength(100),
			])
      ],
      selectedEntity: ['', Validators.compose([
				Validators.required,
				// Validators.minLength(2),
        // Validators.maxLength(100),
			])
      ],
    })
  }
    
  openEntityList(){
    this.api.openEntityList()
    .subscribe(res=>{
      this.entityList = res;
    },
    err=>{
    })
  }
  detectInstituteChange(){
    let qac = this.selectedEntity.qac;
    this.api.getEntityByQac(qac)
    .subscribe(res=>{
      this.entity = res;
      this.session = res.activeSession.name
      this.logoFlag = true;
      this.ref.detectChanges();
      setTimeout(() => {
        for(let item of this.entityList){
          if(item._id == this.entity._id){
            this.selectedEntity = item;
            this.ref.detectChanges();
          }
        }
      }, 1000);
    },err=>{
      this.logoFlag = false;
    })
  
  }
  submit(){
		const controls = this.loginForm.controls;

    if (this.loginForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
    }
    this.loading = true;

    const authData = {
      phone : this.loginForm.controls.mobile.value,
      password : this.loginForm.controls.password.value,
      entity: this.selectedEntity._id,
      session: this.session
    }
    this.api.studentLogin(authData)
    .subscribe(
      res=>  {
        localStorage.setItem('token', res.token)
        localStorage.setItem('name', res.name);
        localStorage.setItem('userType', res.userType)
        localStorage.setItem('mobile', res.phone);
        localStorage.setItem('permissions', res.permissions)
        localStorage.setItem('primaryColour', '#1ca9c9');
        localStorage.setItem('secondaryColour', '#ffffff');
        this.menuAside.loadMenu();
        this.menuHorizontal.loadMenu();
      switch(res.userType){
        // case "od1":
        //   // this.util.redirect('/dashboard')
        //   window.location.href = this.browserDomain + '/dashboard';
        //   break;
        // case "od2":
        // case "od3":
          case "od4":
          localStorage.setItem('entityId', res.entity._id);
          // if(res.entityGroup){
          //   localStorage.setItem('entityGroup', JSON.stringify(res.entityGroup))
          // }
          // else{
          //   localStorage.setItem('entityGroup', JSON.stringify([]))
          // }
          localStorage.setItem('qac', res.entity.qac);
          localStorage.setItem('batch', res.batch);
          localStorage.setItem('studentId', res._id);
          localStorage.setItem('category', res.category);
          localStorage.setItem('course', res.course);
          localStorage.setItem('dob', res.dob);
          localStorage.setItem('gender', res.gender);
          localStorage.setItem('oldNew', res.oldNew);
          localStorage.setItem('regNo', res.regNo);
          localStorage.setItem('rollNo', res.rollNo);
          localStorage.setItem('section', res.section);
          localStorage.setItem('session', res.session);
          localStorage.setItem('status', res.status);
          localStorage.setItem('stream', res.stream);
          localStorage.setItem('logo', res.entity.logo);
          localStorage.setItem('staticQR', res.entity.staticQR);
          localStorage.setItem('tourStage',res.entity.tourStage)
          localStorage.setItem('welcomeTour',res.entity.welcomeTour)
          localStorage.setItem('entityData', JSON.stringify(res.entity));
          localStorage.setItem('entityPreferences', JSON.stringify(res.entity.entityPreferences))
          if(res.entity.entityPreferences && res.entity.entityPreferences.primaryColour){
            localStorage.setItem('primaryColour', res.entity.entityPreferences.primaryColour);
            if(res.entity.entityPreferences.primaryColour == '#ffffff' || res.entity.entityPreferences.primaryColour == '#fff'){
              localStorage.setItem('primaryColour', '#1ca9c9');
            }
          }
          if(res.entity.entityPreferences && res.entity.entityPreferences.secondaryColour){
            localStorage.setItem('secondaryColour', res.entity.entityPreferences.secondaryColour);
          }
          if(res.entity.communicationSetup){
            localStorage.setItem('communicationSetup', JSON.stringify(res.entity.communicationSetup))
            }
          // localStorage.setItem('entityName', res.entity.name)
          localStorage.setItem('entityName', res.entity.displayName)
          localStorage.setItem('entityType', res.entity.entityType)
          // if(!res.entity.activeSession){
          //   this.util.alertNotificationMessage('Please Activate A Session First');
            // this.router.navigate(['/academicSession'])
          // window.location.href = this.browserDomain + '/schoolSetup/academicSession';
            // this.util.redirect('/academicSession')
            // return
          // }else{
          localStorage.setItem('activeSession', res.entity.activeSession.name);
          localStorage.setItem('superSession', res.entity.activeSession.superSession);
          localStorage.setItem('activeSessionStartDate', res.entity.activeSession.startDate);
          localStorage.setItem('activeSessionEndDate', res.entity.activeSession.endDate);
          window.location.href = this.browserDomain + '/studentDashboard';
          // this.util.redirect('/entityDashboard')
          // }
          break;
          default:{
            this.util.redirect('/auth/register')
          }
            }
            this.loading = false;

      },
      err=>{
        this.loading= false;
        this.errorMessage = err.error.message;
        this.authNoticeService.setNotice(this.errorMessage, 'danger');
        this.HarError = true;
      }
      )
			
  }
  trackByIndex(index: number, obj: any): any {
    return index;
}
  isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.loginForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}

}
